import { METADATA_TYPE } from "@/constants/metadata-types"

import type { ConversationMetricRule } from "@/types/api/ConversationMetricRule"

export const CONVERSATION_METRIC_RULE_MATCH_TYPES: Record<
  ConversationMetricRule["metadataType"],
  Array<{
    value: ConversationMetricRule["matchType"]
    label: string
    description: string
  }>
> = {
  STRING: [
    {
      value: "EQUALS",
      label: "Equals",
      description: "Value must exactly match.",
    },
    {
      value: "CONTAINS",
      label: "Contains",
      description: "Value must contain this text.",
    },
    {
      value: "STARTS_WITH",
      label: "Starts With",
      description: "Value must start with this text.",
    },
    {
      value: "ENDS_WITH",
      label: "Ends With",
      description: "Value must end with this text.",
    },
  ],
  BOOLEAN: [],
  STRING_ARRAY: [
    {
      value: "CONTAINS_ANY",
      label: "Contains Any",
      description: "Matches if the array contains any of these values.",
    },
    {
      value: "CONTAINS_ALL",
      label: "Contains All",
      description: "Matches if the array contains all of these values.",
    },
    {
      value: "EQUALS",
      label: "Equals",
      description:
        "Matches if the array contains exactly these values in the same order.",
    },
    {
      value: "LENGTH_AT_LEAST",
      label: "Has At Least",
      description:
        "Matches if the array has at least this many entries, whatever they contain.",
    },
  ],
}

export const formatConversationMetricRuleMatchType = (
  matchType: ConversationMetricRule["matchType"],
) => {
  return matchType
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const formatConversationMetricRuleMetadataValue = (
  metadataType: ConversationMetricRule["metadataType"],
  metadataValue: ConversationMetricRule["metadataValue"],
) => {
  // STRING_ARRAY carries a numeric threshold under LENGTH_AT_LEAST, not a list.
  if (
    metadataType === METADATA_TYPE.STRING_ARRAY &&
    Array.isArray(metadataValue)
  ) {
    return `[${metadataValue.join(", ")}]`
  }

  return String(metadataValue)
}
